interface RatingBadgeProps {
  rating: number;
  size?: "sm" | "md";
}

export default function RatingBadge({ rating, size = "sm" }: RatingBadgeProps) {
  const isLarge = size === "md";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 font-label font-bold text-white ${
        isLarge ? "px-2.5 py-1 text-sm" : "px-2 py-0.5 text-xs"
      }`}
    >
      <i className="ri-star-fill text-[0.7em]" />
      {rating.toFixed(1)}
    </span>
  );
}